var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            title: "委外加工单",
            visible: _vm.show,
            size: "90%",
            "before-close": _vm.handleClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "el-card",
                { attrs: { header: "基础信息" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "委外申请单号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.sn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sn", $$v)
                                  },
                                  expression: "form.sn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据类型", prop: "orderType" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.type == "查看" ||
                                      _vm.isDisabled ||
                                      _vm.isRejectTo,
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.changeOrderType },
                                  model: {
                                    value: _vm.form.orderType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "orderType", $$v)
                                    },
                                    expression: "form.orderType",
                                  },
                                },
                                _vm._l(_vm.orderTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "委外加工供应商",
                                prop: "supplierId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled:
                                      _vm.type == "查看" ||
                                      _vm.isDisabled ||
                                      _vm.isRejectTo,
                                  },
                                  model: {
                                    value: _vm.form.supplierId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "supplierId", $$v)
                                    },
                                    expression: "form.supplierId",
                                  },
                                },
                                _vm._l(_vm.supplierOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "订单状态", prop: "status" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.statusArr[_vm.form.status],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.statusArr,
                                      _vm.form.status,
                                      $$v
                                    )
                                  },
                                  expression: "statusArr[form.status]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建人" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.createUser,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createUser", $$v)
                                  },
                                  expression: "form.createUser",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建时间" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: true,
                                  placeholder: "自动生成",
                                },
                                model: {
                                  value: _vm.form.createTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "createTime", $$v)
                                  },
                                  expression: "form.createTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "铂总量" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    disabled: !(
                                      _vm.form.status == 3 &&
                                      _vm.form.gargoLoadingStatus == 3
                                    ),
                                    type: "number",
                                  },
                                  model: {
                                    value: _vm.form.platinumTotal,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "platinumTotal", $$v)
                                    },
                                    expression: "form.platinumTotal",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("g"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "钯总量" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    disabled: !(
                                      _vm.form.status == 3 &&
                                      _vm.form.gargoLoadingStatus == 3
                                    ),
                                    type: "number",
                                  },
                                  model: {
                                    value: _vm.form.palladiumTotal,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "palladiumTotal", $$v)
                                    },
                                    expression: "form.palladiumTotal",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("g"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "铑总量" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    disabled: !(
                                      _vm.form.status == 3 &&
                                      _vm.form.gargoLoadingStatus == 3
                                    ),
                                    type: "number",
                                  },
                                  model: {
                                    value: _vm.form.rhodiumTotal,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "rhodiumTotal", $$v)
                                    },
                                    expression: "form.rhodiumTotal",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("g"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      [3].includes(_vm.form.status)
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "加工费用" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "70%" },
                                    attrs: {
                                      disabled:
                                        _vm.form.gargoLoadingStatus == 5,
                                      type: "number",
                                      placeholder: "请输入加工费",
                                    },
                                    model: {
                                      value: _vm.form.processAmount,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "processAmount", $$v)
                                      },
                                      expression: "form.processAmount",
                                    },
                                  }),
                                  (_vm.form.processAmount &&
                                    _vm.form.gargoLoadingStatus != 5) ||
                                  (_vm.form.status == 3 &&
                                    _vm.form.gargoLoadingStatus == 3)
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.expenseConfirm()
                                            },
                                          },
                                        },
                                        [_vm._v("保存")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "" } },
                [
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activePaneName,
                        callback: function ($$v) {
                          _vm.activePaneName = $$v
                        },
                        expression: "activePaneName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "订单明细", name: "mountings" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-end",
                                "align-items": "center",
                                "margin-bottom": "10px",
                              },
                            },
                            [
                              [3].includes(_vm.form.status) && _vm.isExpense
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPurchase()
                                        },
                                      },
                                    },
                                    [_vm._v("录入采购订单")]
                                  )
                                : _vm._e(),
                              [2, 3, 4, 5].includes(_vm.form.gargoLoadingStatus)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.addFinishedProduct()
                                        },
                                      },
                                    },
                                    [_vm._v("录入加工成品")]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled:
                                      _vm.type == "查看" || _vm.isRejectTo,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addOutsourceLineModels()
                                    },
                                  },
                                },
                                [_vm._v("新增一行")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    disabled:
                                      _vm.type == "查看" || _vm.isRejectTo,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delectOutsourceLineModels()
                                    },
                                  },
                                },
                                [_vm._v("一键清空列表")]
                              ),
                              _vm.form.orderType === 2 ||
                              _vm.form.orderType === "2"
                                ? _c("excel-import", {
                                    attrs: {
                                      "is-download-template": false,
                                      "template-name":
                                        "CrmOutsourceProcessingLineDataImport.xlsx",
                                      url: "/crm/outsource/line/excelImport",
                                      template:
                                        "CrmOutsourceProcessingLineDataImport.xlsx",
                                      "class-name":
                                        "CrmOutsourceProcessingLineDataImport",
                                      title: "导入",
                                    },
                                    on: {
                                      resdata: _vm.getOutsourceProcessingLine,
                                    },
                                  })
                                : _vm._e(),
                              _vm.form.orderType === 2 ||
                              _vm.form.orderType === "2"
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleOutsourceProcessingDownload()
                                        },
                                      },
                                    },
                                    [_vm._v("下载模版")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-table",
                            {
                              ref: "mountingsTable",
                              attrs: {
                                data: _vm.form.crmOutsourceProcessingLineModels,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料编码",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(_vm._s(scope.row.productCode)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料名称",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(_vm._s(scope.row.productName)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "订单数量",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm.type == "查看" || _vm.isRejectTo
                                          ? _c("div", [
                                              _vm._v(_vm._s(scope.row.qty)),
                                            ])
                                          : _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "crmOutsourceProcessingLineModels." +
                                                    scope.$index +
                                                    ".qty",
                                                  rules:
                                                    _vm
                                                      .crmOutsourceProcessingLineModels
                                                      .qty,
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "number",
                                                    disabled:
                                                      _vm.type == "查看" ||
                                                      _vm.isRejectTo,
                                                    placeholder: "请填写",
                                                  },
                                                  model: {
                                                    value: scope.row.qty,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "qty",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression: "scope.row.qty",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "批次",
                                  align: "left",
                                  width: "150",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(_vm._s(scope.row.batch)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "产值",
                                  align: "left",
                                  width: "150",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(_vm._s(scope.row.twcOutput)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "单位",
                                  align: "left",
                                  width: "100",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(_vm._s(scope.row.unit)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  fixed: "right",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              disabled:
                                                _vm.type == "查看" ||
                                                _vm.isRejectTo,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleMountingsDelete(
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: "实验室投入",
                            disabled: !(
                              _vm.form.orderType === 2 ||
                              _vm.form.orderType === "2"
                            ),
                            name: "flotsam",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-end",
                                "align-items": "center",
                                "margin-bottom": "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled:
                                      _vm.type == "查看" || _vm.isRejectTo,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addOutsourceInputModels()
                                    },
                                  },
                                },
                                [_vm._v("新增一行")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    disabled:
                                      _vm.type == "查看" || _vm.isRejectTo,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delectOutsourceInputModels()
                                    },
                                  },
                                },
                                [_vm._v("一键清空列表")]
                              ),
                              _vm.form.orderType === 2 ||
                              _vm.form.orderType === "2"
                                ? _c("excel-import", {
                                    attrs: {
                                      "is-download-template": false,
                                      "template-name":
                                        "CrmOutsourceProcessingInputDataImport.xlsx",
                                      url: "/crm/outsource/input/excelImport",
                                      template:
                                        "CrmOutsourceProcessingInputDataImport.xlsx",
                                      "class-name":
                                        "CrmOutsourceProcessingInputDataImport",
                                      title: "导入",
                                    },
                                    on: {
                                      resdata: _vm.getOutsourceProcessingInput,
                                    },
                                  })
                                : _vm._e(),
                              _vm.form.orderType === 2 ||
                              _vm.form.orderType === "2"
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "5px" },
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleOutsourceProcessingInputDownload()
                                        },
                                      },
                                    },
                                    [_vm._v("下载模版")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-table",
                            {
                              ref: "mountingsInputTable",
                              attrs: {
                                data: _vm.form
                                  .crmoutsourceprocessinginputmodels,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料编码",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productCode" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料名称",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productName" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "数量",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "crmoutsourceprocessinginputmodels." +
                                                scope.$index +
                                                ".qty",
                                              rules:
                                                _vm
                                                  .crmoutsourceprocessinginputmodels
                                                  .qty,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "number",
                                                disabled:
                                                  _vm.type == "查看" ||
                                                  _vm.isRejectTo,
                                                placeholder: "请填写",
                                              },
                                              model: {
                                                value: scope.row.qty,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "qty",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "scope.row.qty",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "批次",
                                  align: "left",
                                  width: "150",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "batch" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.batch,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "batch",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.batch",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "产值",
                                  align: "left",
                                  width: "150",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "twcOutput" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.twcOutput,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "twcOutput",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.twcOutput",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  fixed: "right",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              disabled:
                                                _vm.type == "查看" ||
                                                _vm.isRejectTo,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleMountingsInputDelete(
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: "实验室产出",
                            disabled: !(
                              _vm.form.orderType === 2 ||
                              _vm.form.orderType === "2"
                            ),
                            name: "spareParts",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-end",
                                "align-items": "center",
                                "margin-bottom": "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled:
                                      _vm.type == "查看" || _vm.isRejectTo,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addOutsourceOutputModels()
                                    },
                                  },
                                },
                                [_vm._v("新增一行")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    disabled:
                                      _vm.type == "查看" || _vm.isRejectTo,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delectOutsourceOutputModels()
                                    },
                                  },
                                },
                                [_vm._v("一键清空列表")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-table",
                            {
                              ref: "flotsamOutputTable",
                              attrs: {
                                data: _vm.form
                                  .crmoutsourceprocessingoutputmodels,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料编码",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productCode" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "物料名称",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "productName" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.productName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "productName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.productName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "数量",
                                  align: "left",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "crmOutsourceProcessingLineModels." +
                                                scope.$index +
                                                ".qty",
                                              rules:
                                                _vm
                                                  .crmOutsourceProcessingLineModels
                                                  .qty,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "number",
                                                disabled:
                                                  _vm.type == "查看" ||
                                                  _vm.isRejectTo,
                                                placeholder: "请填写",
                                              },
                                              model: {
                                                value: scope.row.qty,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "qty",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "scope.row.qty",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "批次",
                                  align: "left",
                                  width: "150",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "batch" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: true,
                                                placeholder: "自动生成",
                                              },
                                              model: {
                                                value: scope.row.batch,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "batch",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.batch",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  fixed: "right",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              disabled:
                                                _vm.type == "查看" ||
                                                _vm.isRejectTo,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleMountingsOutputDelete(
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "流程审批" } },
                [
                  _vm.form.status <= 1 || _vm.form.status == null
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "选择流程模板",
                                        prop: "flowPathTemplateId",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { placeholder: "选择模板" },
                                          on: {
                                            change: _vm.getFlowTempInfoList,
                                          },
                                          model: {
                                            value: _vm.form.flowPathTemplateId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "flowPathTemplateId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.flowPathTemplateId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.flowPathOptions,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.templateName,
                                                value: item.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.form.flowPathNodePersonModels &&
                          _vm.form.flowPathNodePersonModels.length > 0
                            ? _c(
                                "el-table",
                                {
                                  ref: "elTable",
                                  staticStyle: { width: "50%" },
                                  attrs: {
                                    data: _vm.form.flowPathNodePersonModels,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "节点名称",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop: "nodePersonName",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.nodePersonName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3691834225
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "审批人",
                                      align: "left",
                                      "show-overflow-tooltip": "",
                                      width: "auto",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    prop:
                                                      "flowPathNodePersonModels." +
                                                      scope.$index +
                                                      ".nodePerson",
                                                    rules:
                                                      _vm
                                                        .flowPathNodePersonModels
                                                        .nodePerson,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        readonly: "",
                                                        placeholder:
                                                          "请点击图标选择",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.nodePerson,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "nodePerson",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.nodePerson",
                                                      },
                                                    },
                                                    [
                                                      scope.row.variable
                                                        ? _c("el-button", {
                                                            attrs: {
                                                              slot: "append",
                                                              icon: "el-icon-search",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectNodePerson(
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                            slot: "append",
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4032877737
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("Flow", {
                    ref: "flow",
                    attrs: {
                      disabled: _vm.type == "查看" || _vm.form.status > 2,
                      "custom-event": true,
                      "flow-id": _vm.form.flowId,
                    },
                    on: {
                      flowLoad: _vm.flowLoad,
                      complete: _vm.onComplete,
                      refresh: _vm.flowRefresh,
                      rejectTo: _vm.flowRejectTo,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { padding: "10px 20px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: [3].includes(_vm.form.status),
                        loading: _vm.loading,
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("form", false)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm.form.id && (_vm.form.status == 1 || !_vm.form.status)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveAndSubmit()
                            },
                          },
                        },
                        [_vm._v("提交")]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择审批人",
            visible: _vm.showObj.nodePerson,
            width: "30%",
            "before-close": _vm.nodePersonClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "nodePerson", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入审批人名称" },
                    model: {
                      value: _vm.condition.nodePerson.nodePerson,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.nodePerson, "nodePerson", $$v)
                      },
                      expression: "condition.nodePerson.nodePerson",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getNodePersonDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.nodePerson, border: "", height: "300" },
              on: { "selection-change": _vm.handleNodePersonSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "审批人",
                  align: "left",
                  prop: "nodePerson",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.nodePerson.total,
                  page: _vm.pagination.nodePerson.current,
                  limit: _vm.pagination.nodePerson.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.nodePerson,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.nodePerson, "size", $event)
                  },
                  pagination: _vm.getNodePersonDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.nodePersonClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.nodePersonConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品配料",
            visible: _vm.showObj.mountings,
            width: "70%",
            "before-close": _vm.mountingsClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "mountings", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.mountings.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productName", $$v)
                      },
                      expression: "condition.mountings.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.mountings.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "productCode", $$v)
                      },
                      expression: "condition.mountings.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入OE" },
                    model: {
                      value: _vm.condition.mountings.oeCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "oeCode", $$v)
                      },
                      expression: "condition.mountings.oeCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入车牌" },
                    model: {
                      value: _vm.condition.mountings.carNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.mountings, "carNo", $$v)
                      },
                      expression: "condition.mountings.carNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getMountings("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.mountings,
                  expression: "loadingObj.mountings",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.mountings, border: "", height: "300" },
              on: { "selection-change": _vm.handleMountingsChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  width: "150",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "OE",
                  align: "left",
                  width: "150",
                  prop: "oeCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "批次号",
                  align: "left",
                  width: "150",
                  prop: "batch",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车辆ID",
                  align: "left",
                  width: "150",
                  prop: "carId",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产值",
                  align: "left",
                  width: "150",
                  prop: "twcOutput",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车牌",
                  align: "left",
                  width: "150",
                  prop: "carNo",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  align: "left",
                  prop: "brand",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "车系",
                  align: "left",
                  prop: "series",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "年款",
                  align: "left",
                  prop: "modelYear",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发动机型号",
                  align: "left",
                  prop: "engineModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "变速箱型号",
                  align: "left",
                  prop: "transmissionModel",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "排量",
                  align: "left",
                  prop: "displacement",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.mountings.total,
                  page: _vm.pagination.mountings.current,
                  limit: _vm.pagination.mountings.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.mountings, "size", $event)
                  },
                  pagination: _vm.getMountings,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.mountingsClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.mountingsConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "产品废料",
            visible: _vm.showObj.flotsam,
            width: "60%",
            "before-close": _vm.flotsamClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "flotsam", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.flotsam.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.flotsam, "productName", $$v)
                      },
                      expression: "condition.flotsam.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.flotsam.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.condition.flotsam, "productCode", $$v)
                      },
                      expression: "condition.flotsam.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getFlotsam("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.flotsam,
                  expression: "loadingObj.flotsam",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.flotsam, border: "", height: "300" },
              on: { "selection-change": _vm.handleFlotsamChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.flotsam.total,
                  page: _vm.pagination.flotsam.current,
                  limit: _vm.pagination.flotsam.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.flotsam, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.flotsam, "size", $event)
                  },
                  pagination: _vm.getFlotsam,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.flotsamClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.flotsamConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "录入加工成品",
            visible: _vm.showObj.finished,
            width: "80%",
            "before-close": _vm.finishedClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "finished", $event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "align-items": "center",
                "margin-bottom": "10px",
              },
            },
            [
              _vm.form.gargoLoadingStatus != 5
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.addOutsourceFlotsamLine()
                        },
                      },
                    },
                    [_vm._v("新增明细")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.finished,
                  expression: "loadingObj.finished",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.finished, border: "", height: "300" },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "加工后成品",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "加工后成品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "重量（KG）",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.form.gargoLoadingStatus == 5,
                            type: "number",
                            placeholder: "请填写",
                          },
                          model: {
                            value: scope.row.weight,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "weight", _vm._n($$v))
                            },
                            expression: "scope.row.weight",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm.form.gargoLoadingStatus != 5
                ? _c("el-table-column", {
                    attrs: { label: "操作", fixed: "right", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleFinishedDelete(
                                        scope.row.id
                                      )
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2392009207
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.finished.total,
                  page: _vm.pagination.finished.current,
                  limit: _vm.pagination.finished.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.finished, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.finished, "size", $event)
                  },
                  pagination: _vm.getFinished,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.finishedClose } }, [
                _vm._v("关闭"),
              ]),
              _vm.form.gargoLoadingStatus != 5
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.finishedConfirm()
                        },
                      },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "加工产出废料",
            visible: _vm.showObj.outsourceFlotsam,
            width: "60%",
            "before-close": _vm.outsourceFlotsamClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "outsourceFlotsam", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入物料名称" },
                    model: {
                      value: _vm.condition.outsourceFlotsam.productName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.outsourceFlotsam,
                          "productName",
                          $$v
                        )
                      },
                      expression: "condition.outsourceFlotsam.productName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入产品编码" },
                    model: {
                      value: _vm.condition.outsourceFlotsam.productCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.outsourceFlotsam,
                          "productCode",
                          $$v
                        )
                      },
                      expression: "condition.outsourceFlotsam.productCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getOutsourceFlotsam("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingObj.outsourceFlotsam,
                  expression: "loadingObj.outsourceFlotsam",
                },
              ],
              ref: "listTable",
              attrs: {
                data: _vm.dialog.outsourceFlotsam,
                border: "",
                height: "300",
              },
              on: { "selection-change": _vm.handleOutsourceFlotsamChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "物料名称",
                  align: "left",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "产品编码",
                  align: "left",
                  prop: "productCode",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.outsourceFlotsam.total,
                  page: _vm.pagination.outsourceFlotsam.current,
                  limit: _vm.pagination.outsourceFlotsam.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.outsourceFlotsam,
                      "current",
                      $event
                    )
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(
                      _vm.pagination.outsourceFlotsam,
                      "size",
                      $event
                    )
                  },
                  pagination: _vm.getOutsourceFlotsam,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.outsourceFlotsamClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.outsourceFlotsamConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "采购订单信息",
            visible: _vm.showObj.purchase,
            width: "50%",
            "before-close": _vm.purchaseClose,
            "destroy-on-close": "",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "purchase", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "purchaseForm",
              attrs: {
                model: _vm.purchaseRow,
                rules: _vm.purchaseRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "采购订单号", prop: "poNo" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true, placeholder: "自动生成" },
                    model: {
                      value: _vm.purchaseRow.poNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseRow, "poNo", $$v)
                      },
                      expression: "purchaseRow.poNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "sap采购订单号", prop: "sapPoNo" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true, placeholder: "自动生成" },
                    model: {
                      value: _vm.purchaseRow.sapPoNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseRow, "sapPoNo", $$v)
                      },
                      expression: "purchaseRow.sapPoNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "交货工厂", prop: "factoryId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", disabled: true },
                      model: {
                        value: _vm.purchaseRow.factoryId,
                        callback: function ($$v) {
                          _vm.$set(_vm.purchaseRow, "factoryId", $$v)
                        },
                        expression: "purchaseRow.factoryId",
                      },
                    },
                    _vm._l(_vm.factoryOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "存储地点", prop: "warehouseCode" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { readonly: "", placeholder: "请点击图标选择" },
                      model: {
                        value: _vm.purchaseRow.warehouseCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.purchaseRow, "warehouseCode", $$v)
                        },
                        expression: "purchaseRow.warehouseCode",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: {
                          slot: "append",
                          icon: "el-icon-search",
                          disabled: _vm.form.gargoLoadingStatus == 5,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selectWarehouse()
                          },
                        },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "供应商", prop: "supplierId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.form.gargoLoadingStatus == 5 },
                      model: {
                        value: _vm.purchaseRow.supplierId,
                        callback: function ($$v) {
                          _vm.$set(_vm.purchaseRow, "supplierId", $$v)
                        },
                        expression: "purchaseRow.supplierId",
                      },
                    },
                    _vm._l(_vm.supplierOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "采购组织",
                    prop: "purchasingOrganizationId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.form.gargoLoadingStatus == 5 },
                      model: {
                        value: _vm.purchaseRow.purchasingOrganizationId,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.purchaseRow,
                            "purchasingOrganizationId",
                            $$v
                          )
                        },
                        expression: "purchaseRow.purchasingOrganizationId",
                      },
                    },
                    _vm._l(_vm.purchasingOrganizationOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购组", prop: "purchaseBasicsId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.form.gargoLoadingStatus == 5 },
                      model: {
                        value: _vm.purchaseRow.purchaseBasicsId,
                        callback: function ($$v) {
                          _vm.$set(_vm.purchaseRow, "purchaseBasicsId", $$v)
                        },
                        expression: "purchaseRow.purchaseBasicsId",
                      },
                    },
                    _vm._l(_vm.purchaseBasicsOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单价", prop: "unitPrice" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      disabled: _vm.form.gargoLoadingStatus == 5,
                      placeholder: "请输入单价",
                      clearable: "",
                    },
                    model: {
                      value: _vm.purchaseRow.unitPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseRow, "unitPrice", $$v)
                      },
                      expression: "purchaseRow.unitPrice",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "总金额", prop: "sumPrice" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "number",
                      disabled: _vm.form.gargoLoadingStatus == 5,
                      placeholder: "请输入总金额",
                      clearable: "",
                    },
                    model: {
                      value: _vm.purchaseRow.sumPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseRow, "sumPrice", $$v)
                      },
                      expression: "purchaseRow.sumPrice",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "进项税", prop: "taxCode" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.form.gargoLoadingStatus == 5 },
                      model: {
                        value: _vm.purchaseRow.taxCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.purchaseRow, "taxCode", $$v)
                        },
                        expression: "purchaseRow.taxCode",
                      },
                    },
                    _vm._l(_vm.inputTaxOptions, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label: item.name + "-" + item.code,
                          value: item.name,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.form.gargoLoadingStatus == 5,
                      placeholder: "请输入备注",
                      clearable: "",
                    },
                    model: {
                      value: _vm.purchaseRow.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseRow, "remark", $$v)
                      },
                      expression: "purchaseRow.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.form.gargoLoadingStatus != 5
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.purchaseConfirm },
                        },
                        [_vm._v("确认")]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.purchaseClose } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "选择存储地点",
            visible: _vm.showObj.warehouse,
            width: "60%",
            "before-close": _vm.warehouseClose,
            "destroy-on-close": "",
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showObj, "warehouse", $event)
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入存储代码" },
                    model: {
                      value: _vm.condition.warehouse.warehouseNumber,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.condition.warehouse,
                          "warehouseNumber",
                          $$v
                        )
                      },
                      expression: "condition.warehouse.warehouseNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.getWarehouseDialog("refresh")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "listTable",
              attrs: { data: _vm.dialog.warehouse, border: "", height: "300" },
              on: { "selection-change": _vm.handleWarehouseSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "存储代码",
                  align: "left",
                  prop: "warehouseNumber",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "存储描述",
                  align: "left",
                  prop: "warehouseName",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "footer-box" },
            [
              _c("pagination", {
                attrs: {
                  total: _vm.pagination.warehouse.total,
                  page: _vm.pagination.warehouse.current,
                  limit: _vm.pagination.warehouse.size,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.warehouse, "current", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pagination.warehouse, "size", $event)
                  },
                  pagination: _vm.getWarehouseDialog,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.warehouseClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.warehouseConfirm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }